// src/api/sentDataToCustomersArchive.js
import jwtAxios from '@crema/services/auth/jwt-auth';
import {handleError} from './handleError';

/**
 * Fetch data for Sent Data to Customers Archive with pagination and filters
 * @param {number} page - The current page number (zero-based)
 * @param {object} filters - The filter parameters
 * @param {string} filters.domainId - ID of the selected domain
 * @param {string} filters.customerId - ID of the selected customer
 * @param {[Date, Date]} filters.dateRange - Start and end dates
 * @param {number} pageSize - Number of rows per page
 * @returns {Promise<{ data: array, count: number }>}
 */
export const getSentDataToCustomersArchive = async (page, filters, pageSize = 100) => {
  const {domain_id, customer_id, dateRange} = filters;
  let fromDate;
  let toDate;
  
  if (dateRange && dateRange[0]) {
    const date = dateRange[0] instanceof Date ? dateRange[0] : new Date(dateRange[0]);
    if (!isNaN(date.getTime())) {
      fromDate = date.toISOString();
    }
  }
  
  if (dateRange && dateRange[1]) {
    const date = dateRange[1] instanceof Date ? dateRange[1] : new Date(dateRange[1]);
    if (!isNaN(date.getTime())) {
      // Set to end of day
      date.setHours(23, 59, 59, 999);
      toDate = date.toISOString();
    }
  }

  try {
    const response = await jwtAxios.get('archive/sentDataToCustomersArchive', {
      params: {
        pageNumber: page, // Zero-based page number
        pageSize: pageSize,
        fromDate,
        toDate,
        domain_id, // Add domainId as a parameter
        customer_id, // Add customerId as a parameter
      },
    });

    console.log('Response data: ', response.data);

    const {data, totalCount} = response.data;

    return {data: data || [], count: totalCount || 0};
  } catch (error) {
    return handleError(error);
  }
};
